import React from 'react'
import { Btn, CustomDataTableHeader } from '../../../../components'
import { Column } from 'primereact/column'
import { DataTable } from 'primereact/datatable'
import { gerarArquivoExcel } from '../../../../services/util/excel.service'
import TabHistoricoModal from './TabHistoricoModal'
import './TabHistorico.css'
import { formatDateToLocale } from '../../../../services/util/date.service'

const EXCEL_COLUMNS = [
  { header: 'Horário', get: b => b.horario },
  { header: 'Produto', get: b => b.produto },
  { header: 'Vol', get: b => b.vol },
  { header: 'Uni', get: b => b.uni },
  { header: 'Área', get: b => b.area },
  { header: 'Apelido', get: b => b.apelido },
  { header: 'Equipe', get: b => b.equipe },
  { header: 'Usuário', get: b => b.usuario_name },
  { header: 'Num. Pallet', get: b => b.pallet_area_id, onlyWithNumPallet: true },
  { header: 'Lote', get: b => b.lote },
  { header: 'Info Complementar', get: b => b.info_complementar },
]

const TabHistorico = ({
  bips,
  pickingId,
  showNumPallet = true,
  excelFileName = 'historico_leitura.xlsx',
}) => {
  const [globalFilter, setGlobalFilter] = React.useState('')
  const [selectedBip, setSelectedBip] = React.useState(null)
  // Render
  return (
    <>
      <div className="p-grid p-col-12">
        <div className="p-col-12">
          <Btn
            onClick={() => {
              const columns = EXCEL_COLUMNS.filter(c => showNumPallet || !c.onlyWithNumPallet)
              const data = [columns.map(c => c.header)]
              bips.forEach(b => {
                data.push(columns.map(c => c.get(b)))
              })
              gerarArquivoExcel('Histórico', data, excelFileName)
            }}
          >
            Exportar
          </Btn>
        </div>
        <div className="p-col-12 p-datatable-responsive">
          <DataTable
            value={bips}
            emptyMessage={'Não existe Histórico de Leitura/Bip'}
            header={
              <div style={{ width: '100%', height: 50 }}>
                <CustomDataTableHeader onChange={setGlobalFilter} />
              </div>
            }
            globalFilter={globalFilter}
            rows={15}
            paginator={true}
            selectionMode={'single'}
            onSelectionChange={e => setSelectedBip(e.value)}
            responsive={true}
          >
            <Column
              field={'horario'}
              header={'Horário'}
              className="column-responsive"
              style={{ width: '140px' }}
              body={h => {
                if (h.horario && h.horario !== '-') {
                  try {
                    return formatDateToLocale(h.horario, 'dd/MM/yy HH:mm:ss').toFormat(
                      'dd/MM/yy HH:mm:ss',
                    )
                  } catch (e) {
                    return '-'
                  }
                }
                return '-'
              }}
            />
            <Column
              field={'produto'}
              header={'Produto'}
              className="column-responsive column-important"
            />
            <Column
              field={'vol'}
              header={'Vol'}
              className="column-number"
              style={{ width: '80px' }}
            />
            <Column
              field={'uni'}
              header={'Uni'}
              className="column-number"
              style={{ width: '80px' }}
            />
            <Column
              field={'area'}
              header={'Área'}
              className="column-responsive"
              style={{ width: '100px' }}
            />
            <Column
              field={'apelido'}
              header={'Apelido'}
              className="column-responsive"
              style={{ width: '120px' }}
            />
            <Column
              field={'equipe'}
              header={'Equipe'}
              className="column-responsive"
              style={{ width: '100px' }}
            />
            <Column
              field={'usuario_name'}
              header={'Usuário'}
              className="column-responsive md-hide"
            />
            {showNumPallet && (
              <Column
                field={'pallet_area_id'}
                header={'Num. Pallet'}
                className="column-responsive"
                style={{ width: '120px' }}
              />
            )}
          </DataTable>
        </div>
      </div>
      <TabHistoricoModal
        onClose={() => setSelectedBip(null)}
        visible={selectedBip !== null}
        bip={selectedBip}
        pickingId={pickingId}
        showNumPallet={showNumPallet}
      />
    </>
  )
}

export default TabHistorico
